<template>
    <div class="component__view">
        <div class="title"></div>

        <div class="uis">
            <div class="score-info needLang ali">剩余狂欢积分：{{ score || 0 }}</div>
            <div class="u-btn trade-history" @click="call_record()"></div>
        </div>

        <div class="m-score-shop">
            <div class="shop-pannel">
                <div class="shop-view">
                    <vuescroll>
                        <div class="shop-list flex-start-start flex-wrap">
                            <div class="shop-item" v-for="(item,index) in score_list" :key="item.id">
                                
                                <div class="item-name">{{ item.giftName.replace(/（\d+天）|\(\d+天\)/, "") }}</div>

                                <div class="reward-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>

                                <div class="item-cnt"><span v-if="item.max">{{ item.orderNum }}/</span>{{ item.max ? item.max : '不限量'}}</div>

                                <div class="price flex-center-center">
                                    <div class="amt">{{ item.amt }}</div>
                                    <em class="icon-token"></em>
                                </div>

                                <div class="u-btn apply" :class="{ 'dismiss' : item.orderNum == item.max && item.max }" @click="call_trade(item)">兑换</div>
                            </div>
                        </div>
                    </vuescroll>                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    apiScoreList,
    apiUserScore,
    apiUserRecord,
} from '@/api/index';

export default {
    data (){
        return {
            score_list : [],
            score : 0,
        }
    },
    mounted(){
        this.init();
    },
    computed:{
        ex_list (){
            return this.$store.state.ex_list;
        },        
    },
    watch: {
        ex_list : {
            handler(newVal, oldVal) {
                this.score_list = newVal;
                this.get_score();
            },
            deep: true
        },                
    },         
    methods : {
        init(){
            apiScoreList().then(
                res => {
                    this.score_list = res.data;
                    this.$store.commit("$_setExList", res.data);
                },
            )
        },
        call_trade(item){

            if(!this.$store.state.login){
                return this.$mslogin.login();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            if(item.orderNum == item.max && item.max){
                return this.$toast('该商品已兑换完毕~');
            }

            this.$comfirmwarn_trade({ item : item })
        },
        get_score(){
            apiUserScore().then(
                res => {
                    this.score = this.$global.isDataEmpty(res.data) ? 0 : res.data['0'].score;
                },
                rej => {

                }
            )
        },
        call_record (){
            if(!this.$store.state.login){
                return this.$mslogin.login();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            apiUserRecord({type : 2}).then(
                res => {
                    this.$record_modal({ list : res.data });
                },
                rej => {},
            )
        },        
    }    
}
</script>

<style lang="scss" scoped>
.component__view{
    width: 750px;
    height: 2266px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center top;
    box-sizing: border-box;
    background-image: url(~@/assets/images/score/body.jpg);    
}

.title{
    width: 711px;
    height: 230px;
    margin: 0 auto 30px;
    background-image: url(~@/assets/images/score/title.png); 
}

.uis{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 20px 28px;

    .score-info{
        position: relative;
        width: 315px;
        height: 44px;
        line-height: 44px;
        padding-left: 30px;
        color: #ea583f;
        box-sizing: border-box;
        background-image: url(~@/assets/images/score/bg-score.png);

        &::after{
            content: '';
            display: block;
            position: absolute;
            right:-16px;
            top: 50%;
            width: 39px;
            height: 36px;
            margin-top: -18px;
            background-image: url(~@/assets/images/score/icon-token-mid.png);
        }
    }

    .trade-history{
        width: 158px;
        height: 44px;
        background-image: url(~@/assets/images/score/btn-his.png);
    }
}

.shop-pannel{
    width: 750px;
    height: 1984px;
    margin: 0 auto;
    padding-top: 40px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/score/pannel.png);

    .shop-view{
        padding: 0 16px 0 30px;
        height: 1800px;
    }

    .shop-item{
        position: relative;
        width: 321px;
        height: 360px;
        margin: 0 13px 26px;
        padding-top: 38px;
        box-sizing: border-box;
        background-image: url(~@/assets/images/shop/shop-item.png);

        .u-btn.apply{
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 76px;
            line-height: 76px;
            text-align: center;
            color: #fef6db;
            background-color: #ef6b4a;
            border-radius: 0 0 12px 12px;
        }
    }

    .reward-pic{
        width: 69px;
        height: 69px;
        margin: 0 auto 8px;
    }

    .item-name{
        margin-bottom: 8px;
        font-size: 24px;
        font-weight: 700;
        color: #4c4c4c;
        text-align: center;
    }

    .item-cnt{
        font-size: 22px;
        font-weight: 700;
        color: #6a6a6a;
        text-align: center;
    }

    .price{
        position: relative;
        margin-top: 16px;
        padding: 0 20px;

        .icon-token{
            display: block;
            width: 51px;
            height: 46px;
            background-image: url(~@/assets/images/score/icon-token-lg.png);
        }
    }

    .amt{
        font-size: 68px;
        color: #e8533d;
        font-family: 'spNum';
    }


}
</style>